'use es6';

import { fetchGraphQLFiles } from 'DesignData/api/DataQueries';
import { GRAPHQL_FILES_FETCH } from 'DesignData/actions/ActionTypes';
/*
 * GET designmanager/v1/templates
 */

export function fetch() {
  const {
    request,
    receive,
    error
  } = fetch;
  return dispatch => {
    dispatch(request());
    return fetchGraphQLFiles().then(graphqlFiles => {
      dispatch(receive(graphqlFiles));
    }).catch(__error => {
      dispatch(error(__error));
    });
  };
}

fetch.request = function request() {
  return {
    type: GRAPHQL_FILES_FETCH
  };
};

fetch.receive = function receive(graphqlfiles) {
  return {
    type: GRAPHQL_FILES_FETCH,
    payload: graphqlfiles
  };
};

fetch.error = function error(err) {
  return {
    type: GRAPHQL_FILES_FETCH,
    error: err
  };
};